import { useState } from 'react';
import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';
import { Link } from 'react-router-dom';
import { galleryItems } from '../../mocks/gallery';

const rooms = ['All', 'Living Room', 'Bedroom', 'Dining Room', 'Home Office', 'Outdoor'];

export default function GalleryPage() {
  const [activeRoom, setActiveRoom] = useState('All');
  const filtered = activeRoom === 'All' ? galleryItems : galleryItems.filter((g) => g.room === activeRoom);

  return (
    <div className="min-w-[1024px]">
      <Navbar />
      <main>
        <section className="bg-dark pt-44 pb-20">
          <div className="max-w-4xl mx-auto px-6 text-center">
            <div className="flex items-center justify-center gap-3 mb-5">
              <span className="w-8 h-px bg-gold" />
              <span className="text-gold text-xs font-semibold uppercase tracking-[0.25em]">Inspiration</span>
              <span className="w-8 h-px bg-gold" />
            </div>
            <h1 className="font-serif text-6xl font-bold text-white mb-5">
              Room Inspiration Gallery
            </h1>
            <p className="text-white/50 text-lg">
              Real homes, beautifully furnished. Browse by room to find your inspiration.
            </p>
          </div>
        </section>

        <section className="py-20 bg-cream-mid">
          <div className="max-w-7xl mx-auto px-6">
            <div className="flex flex-wrap gap-3 mb-12 justify-center">
              {rooms.map((r) => (
                <button
                  key={r}
                  onClick={() => setActiveRoom(r)}
                  className={`px-6 py-2.5 rounded-full text-xs font-semibold uppercase tracking-wider transition-all cursor-pointer whitespace-nowrap ${
                    activeRoom === r
                      ? 'bg-gold text-white'
                      : 'bg-white border border-cream-dark text-dark/60 hover:border-gold hover:text-gold'
                  }`}
                >
                  {r}
                </button>
              ))}
            </div>
            <div className="columns-1 sm:columns-2 lg:columns-3 xl:columns-4 gap-4 space-y-4">
              {filtered.map((item) => (
                <div key={item.id} className="break-inside-avoid group relative overflow-hidden rounded-xl cursor-pointer">
                  <img
                    src={item.image}
                    alt={`${item.title} - modern furniture Las Vegas`}
                    title={item.title}
                    className="w-full object-cover object-top group-hover:scale-105 transition-transform duration-600"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-dark/80 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300 flex flex-col justify-end p-5">
                    <span className="text-gold text-[10px] font-bold uppercase tracking-[0.2em] mb-1">{item.room}</span>
                    <span className="text-white font-serif font-bold">{item.title}</span>
                    <span className="text-white/50 text-xs mt-1">{item.location}</span>
                  </div>
                  <div className="absolute top-3 left-3 bg-dark/60 backdrop-blur-sm text-white text-[10px] font-semibold uppercase tracking-wider px-3 py-1 rounded-full">
                    {item.room}
                  </div>
                </div>
              ))}
            </div>
          </div>
        </section>

        <section className="bg-dark py-16">
          <div className="max-w-4xl mx-auto px-6 text-center">
            <h2 className="font-serif text-3xl font-bold text-white mb-4">Love What You See?</h2>
            <p className="text-white/50 mb-8">Visit our showroom and let our design team help bring your vision to life.</p>
            <div className="flex flex-col sm:flex-row gap-4 justify-center">
              <Link to="/showroom" className="bg-gold text-white px-8 py-4 rounded font-bold text-xs uppercase tracking-widest cursor-pointer whitespace-nowrap hover:bg-gold-dark transition-colors">
                Visit Showroom
              </Link>
              <Link to="/collections" className="border border-white/20 text-white px-8 py-4 rounded font-bold text-xs uppercase tracking-widest cursor-pointer whitespace-nowrap hover:border-gold hover:text-gold transition-colors">
                Browse Collections
              </Link>
            </div>
          </div>
        </section>
      </main>
      <Footer />
    </div>
  );
}
